export default {
  users: {},
  leaveType: [],
  roleAssignment: [],
  apiCallsInProgress: 0,
  empy: [],
  notification: []
};
